import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c1142fb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "statusButton" }

import { ref, onMounted } from 'vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'StatusButton',
  props: {
  context: {
    type: String,
    required: false,
  },
  statusName: {
    type: String,
    required: true,
  },
},
  emits: ['onClick_status'],
  setup(__props, { emit }) {

const props = __props;



/**** methods ----------------- */
const setClassName = () => {
  if (props.statusName === '보기') return 'btn-status-detail';
  if (props.statusName === '전체') return 'btn-status-cancel';
  if (props.statusName === '요청') return 'btn-status-request';
  if (props.statusName === '미응답') return 'btn-status-none';
  if (props.statusName === '대기') return 'btn-status-wait';
  if (props.statusName === '반려') return 'btn-status-reject';
  if (props.statusName === '승인') return 'btn-status-accept';
  if (props.statusName === '확정') return 'btn-status-confirm';
  if (props.statusName === '완료') return 'btn-status-finished';
  if (props.statusName === '취소') return 'btn-status-cancel';
  if (props.statusName === '노쇼') return 'btn-status-noshow';
};
/**** content -----------------
 *
 * 상태 버튼
 * /
 * /
/**** hook -------------------- */
onMounted(() => {
  setClassName();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["btn-status", setClassName()]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('onClick_status')))
    }, _toDisplayString(__props.statusName), 3)
  ]))
}
}

})